export default function passwordField(fieldName, isConfirmationField = false, store) {
    return {
        // état UI local (OK de garder this ici)
        visible: false,
        isConfirmation: isConfirmationField,

        init() {
            if (!store) {
                console.warn(`Store not provided for field "${fieldName}"`);
                return;
            }

            /*console.log(
                `PasswordField init field=${fieldName} confirmation=${isConfirmationField}`
            );*/

            const input = this.$el.querySelector('input');

            if (input) {
                store.initField(fieldName, input.value);
            }
        },

        // UI pur
        inputType() {
            return this.visible ? 'text' : 'password';
        },

        buttonLabel() {
            return this.visible ? 'Masquer' : 'Voir le mot de passe';
        },

        buttonClass() {
            return this.visible ? 'btn-hide' : 'btn-show';
        },

        toggle() {
            this.visible = !this.visible;
        },

        // valeur depuis le store (closure)
        get value() {
            return store?.values?.[fieldName] ?? '';
        },

        // règles UI
        get rules() {
            const value = store?.values?.[fieldName] ?? '';

            return {
                length: value.length >= 12,
                uppercase: /[A-Z]/.test(value),
                number: /[0-9]/.test(value),
                special: /[^A-Za-z0-9]/.test(value),
            };
        },

        ruleClass(rule) {
            const rules = this.rules ?? {};
            return rules[rule] ? 'is-valid' : 'is-invalid';
        },

        ruleIcon(rule) {
            const rules = this.rules ?? {};
            return rules[rule] ? '✔' : '✖';
        },

        get isValid() {
            const rules = this.rules ?? {};
            return Object.values(rules).every(Boolean);
        },

        // erreurs
        get errorMessages() {
            return store?.getErrorMessages?.(fieldName) ?? [];
        },

        get hasError() {
            return store?.hasError?.(fieldName) ?? false;
        },

        get errorClass() {
            return (store?.hasError?.(fieldName) ?? false) ? 'has-error' : '';
        },

        // confirmation
        passwordsMatch() {
            if (!isConfirmationField) return true;
            return store?.passwordsMatch?.() ?? true;
        },

        // deprecated
        onBlur() {
            store?.touch?.(fieldName);
        },


        onChange() {
            store?.touch?.(fieldName);
        }
    };
}
